
const loginTokens = ['registerToken','resetPasswordToken'];

export function hasLoginTokenInUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  for (const name of loginTokens) {
    const token = urlParams.get(name);
    if (token) {
        return true;
    }
  }
  return false;
}

const localStorageTokens = ['token', 'refreshToken', 'registerToken', 'resetPasswordToken'];

export function clearLocalStorageTokens() {
  for (const name of localStorageTokens) {
    localStorage.removeItem(name);
  }
}

export function saveLoginTokens() {
  const urlParams = new URLSearchParams(window.location.search);
  for (const name of loginTokens) {
    const token = urlParams.get(name);
    if (token) {
        localStorage.setItem(name, token);
    }
  }
}

export function decodeJWT(token:string) {
  try {
    // Split the JWT into its parts (header, payload, signature)
    const [header, payload, signature] = token.split('.');

    // Decode the base64url-encoded payload
    const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    
    // Parse the decoded payload into a JSON object
    const payloadObj = JSON.parse(decodedPayload);
    
    // Extract the expiration timestamp (in seconds)
    const expirationTimestamp = payloadObj.exp;
    
    // Convert to human-readable date (optional)
    const expirationDate = new Date(expirationTimestamp * 1000);
    
    return {
      payload: payloadObj,
      expirationTimestamp: expirationTimestamp,
      expirationDate: expirationDate,
      isExpired: expirationTimestamp < Math.floor(Date.now() / 1000)
    };
  } catch (error) {
    console.error('Error decoding JWT:', error.message);
    return null;
  }
}

export function isJwtTokenExpired(token:string):boolean {
  const decoded = decodeJWT(token);
  if (decoded) {
    return decoded.isExpired;
  }
}